import React, { useEffect, useRef } from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import testbike from "../images/bikes/1.png";
import banner from "../images/bike-dealer.jpg"
import ReactPlayer from "react-player/lazy";
import { NavLink, useParams } from "react-router-dom";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./bike-example.css"
import DebugImage from "./../components/DebugImage";
import BikeExampleLoading from "./bike-example-loader";
import { FaRegFilePdf } from "react-icons/fa6";
import { useState } from "react";

import telowhite from "../images/vlastnosti/ridley-tělo-white.png";
import teloblack from "../images/vlastnosti/ridley-tělo-black.png";
import builder from "../utils/builderWithLocale";
import { entryMatchesId, getBikeField } from "../editry/cms";
import { getLocalizedText } from "../utils/textLocalization";
import { formatPrice } from "../utils/currencyUtils";
import ExchangeRateTooltip from "../components/ExchangeRateTooltip";
import { getCurrentLanguage } from "../utils/languageSwitcher";
import EditableField from "../editry/EditableField";

// Specification name translations
const SPEC_TRANSLATIONS = {
  'Rám': { HUN: 'Váz', PL: 'Rama', SK: 'Rám' },
  'Rámová sada': { HUN: 'Vázszett', PL: 'Zestaw ramowy', SK: 'Rámová sada' },
  'Vidlice': { HUN: 'Villa', PL: 'Widelec', SK: 'Vidlica' },
  'Tlumič': { HUN: 'Rugóstag', PL: 'Damper', SK: 'Tlmič' },
  'Motor': { HUN: 'Motor', PL: 'Silnik', SK: 'Motor' },
  'Baterie': { HUN: 'Akkumulátor', PL: 'Akumulator', SK: 'Batéria' },
  'Kapacita baterie': { HUN: 'Akkumulátorkapacitás', PL: 'Pojemność baterii', SK: 'Kapacita batérie' },
  'Řazení': { HUN: 'Váltás', PL: 'Przerzutki', SK: 'Prehadzovanie' },
  'Přesmykač': { HUN: 'Első váltó', PL: 'Przerzutka przednia', SK: 'Predná prehadzovačka' },
  'Přehazovačka': { HUN: 'Hátsó váltó', PL: 'Przerzutka tylna', SK: 'Zadná prehadzovačka' },
  'Kliky': { HUN: 'Hajtókar', PL: 'Korby', SK: 'Kľuky' },
  'Kazeta': { HUN: 'Kazetta', PL: 'Kaseta', SK: 'Kazeta' },
  'Brzdy': { HUN: 'Fékek', PL: 'Hamulce', SK: 'Brzdy' },
  'Řidítka': { HUN: 'Kormány', PL: 'Kierownica', SK: 'Riadidlá' },
  'Představec': { HUN: 'Kormányszár', PL: 'Mostek', SK: 'Predstavec' },
  'Sedlovka': { HUN: 'Nyeregcső', PL: 'Sztyca', SK: 'Sedlovka' },
  'Sedlo': { HUN: 'Nyereg', PL: 'Siodło', SK: 'Sedlo' },
  'Zapletená kola': { HUN: 'Kerékszett', PL: 'Koła zaplecione', SK: 'Zapletené kolesá' },
  'Pláště': { HUN: 'Külső gumik', PL: 'Opony', SK: 'Plášte' }
};

const translateSpecName = (czechName) => {
  const locale = getCurrentLanguage();
  if (locale === 'cs-CZ') return czechName; // Czech - no translation needed
  
  const localeMap = {
    'hu-HU': 'HUN',
    'pl-PL': 'PL',
    'sk-SK': 'SK'
  };
  
  const targetLang = localeMap[locale];
  return SPEC_TRANSLATIONS[czechName]?.[targetLang] || czechName;
};

function App({theme, setTitleModal, setTextModal, setModal, setImageModal, setTableModal, tableId, bikeData}) {
  const { id, kategorie } = useParams();
  const [loading, setLoading] = useState(true);
  const [bike, setBike] = useState(null);
  const [currentBikeImage, setCurrentBikeImage] = useState(null);
  const [selectedColorIndex, setSelectedColorIndex] = useState(0);
  const [size, setSize] = useState("M");
  const [dostupneVelikosti, setDostupneVelikosti] = useState([]);
  const [vlastnosti] = useState(true);
  const [vlastnostiExpanded, setVlastnostiExpanded] = useState(-1);
  const [openCategories, setOpenCategories] = useState({});

  const defaultSpecifikace = {
    nazevKategorie: [
      {
        kategorie: "Rám",
        specifikace: [
          { jmenoSpecifikace: "Materiál", hodnotaSpecifikace: "Carbon" },
          { jmenoSpecifikace: "Velikosti", hodnotaSpecifikace: "S, M, L, XL" }
        ]
      }
    ]
  };

  // Reference pro UI elementy
  const boxRef = useRef(null);
  const textRef = useRef(null);

  // Galerie obrázků
  const [galleryImages, setGalleryImages] = useState([]);
  const [showGallery, setShowGallery] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);


  useEffect(() => {
    setLoading(true);
        
        const foundBike = bikeData.find((b) => entryMatchesId(b, id));
        
        if (foundBike) {
          setBike(foundBike);
          window.document.title = `Ridley | ${foundBike.data?.nazev || "Ridley kolo"}`;
          
          // Zpracování velikostí
          if (foundBike.data?.velikosti) {
            const velikosti = [];
            const velikostiData = foundBike.data.velikosti;
            
            if (velikostiData.xxxs) velikosti.push("XXXS");
            if (velikostiData.xxs) velikosti.push("XXS");
            if (velikostiData.xs) velikosti.push("XS");
            if (velikostiData.s) velikosti.push("S");
            if (velikostiData.m) velikosti.push("M");
            if (velikostiData.l) velikosti.push("L");
            if (velikostiData.xl) velikosti.push("XL");
            if (velikostiData.d) velikosti.push("Ď");
            
            setDostupneVelikosti(velikosti);
          }
          
          // Nastavení výchozího obrázku kola
          if (foundBike.data?.obrazek) {
            setCurrentBikeImage(foundBike.data.obrazek);
          }
          
          // Zpracování galerie (oProduktuObrazky / oproduktuobrazky)
          const gallerySource = getBikeField(foundBike.data, 'oProduktuObrazky');
          if (gallerySource && Array.isArray(gallerySource)) {
            const obrazky = gallerySource
              .filter(img => img && img.obrazek)
              .map(img => img.obrazek);
              
            if (obrazky.length > 0) {
              setGalleryImages(obrazky);
            }
          }
          
          // Nastavení počátečních stavů pro rozbalené kategorie
          if (foundBike.data?.specifikace?.[0]?.nazevKategorie) {
            const initialState = {};
            foundBike.data.specifikace[0].nazevKategorie.forEach((_, index) => {
              initialState[index] = false;
            });
            setOpenCategories(initialState);
          }
          
          setLoading(false);
        }


  }, [id, bikeData]);

  // Funkce pro změnu barvy kola
  const handleColorChange = (index) => {
    setSelectedColorIndex(index);
    if (bike?.data?.barvy?.[index]?.obrazek) {
      setCurrentBikeImage(bike.data.barvy[index].obrazek);
    }
  };

  // Funkce pro galerii
  const openGallery = (index) => {
    setCurrentImageIndex(index);
    setShowGallery(true);
  };
  
  const closeGallery = () => {
    setShowGallery(false);
  };
  
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };
  
  const toggleCategory = (kategIndex) => {
    setOpenCategories(prevState => ({
      ...prevState,
      [kategIndex]: !prevState[kategIndex]
    }));
  };
  
  const adjustLetterSpacing = () => {
    const box = boxRef.current;
    const text = textRef.current;
  
    if (box && text) {
      const boxWidth = box.offsetWidth;
      const textContent = text.textContent;
  
      const textWidthWithoutSpacing = Array.from(textContent)
        .map((char) => {
          const span = document.createElement("span");
          span.style.fontSize = window.getComputedStyle(text).fontSize;
          span.style.fontFamily = window.getComputedStyle(text).fontFamily;
          span.style.fontWeight = window.getComputedStyle(text).fontWeight;
          span.textContent = char;
          document.body.appendChild(span);
          const charWidth = span.offsetWidth;
          span.remove();
          return charWidth;
        })
        .reduce((acc, width) => acc + width, 0);
  
      if (textWidthWithoutSpacing < boxWidth && textContent.length > 1) {
        const extraSpace = boxWidth - textWidthWithoutSpacing;
        const letterSpacing = extraSpace / (textContent.length);
        text.style.letterSpacing = `${letterSpacing}px`;
  
        text.style.marginRight = `-${letterSpacing}px`;
      } else {
        text.style.letterSpacing = "0px";
        text.style.marginRight = "0px";
      }
    }
  };

  const handleScroll = (e) => {
    const hash = e.currentTarget.hash.substring(1);
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
      
  
  useEffect(() => {
    adjustLetterSpacing();

    window.addEventListener("resize", adjustLetterSpacing);

    return () => {
      window.removeEventListener("resize", adjustLetterSpacing);
    };
  }, []);

  if (loading) {
    return (
      <motion.div className="page bike-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <BikeExampleLoading />
      </motion.div>
    );
  }

  if (!bike) {
    return (
      <motion.div className="page bike-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <BikeExampleLoading />
      </motion.div>
    );
  }

  const specifikaceList = bike.data?.specifikace?.[0] || defaultSpecifikace;

  const geometrieObrazek = getBikeField(bike.data, 'geometrieObrazek');
  const geometriePdf = getBikeField(bike.data, 'geometriePdf');

  const download = () => {
    if (geometriePdf) {
      window.open(geometriePdf, '_blank', 'noopener,noreferrer');
    } else {
      alert("PDF není k dispozici");
    }
  };

  return (
    <>
      <motion.div className="page bike-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="cesta cesta-bike-example">
          <NavLink to="/#kola" onClick={handleScroll}><button><span>{getLocalizedText('general.bikes_caps')}</span></button></NavLink>
          <NavLink to={"/kola/" + kategorie} ><button><span>{kategorie.toUpperCase() || "loading"}</span></button></NavLink>
          <button className="cesta-active">
            <span>
              <EditableField model="kola" item={bike} field="nazev">
                {bike.data?.nazev || "Ridley bike"}
              </EditableField>
            </span>
          </button>
        </div>


      <div className="page-size-blocked">
        <h1>
          <EditableField model="kola" item={bike} field="nazev">
            {bike.data?.nazev || "Kolo"}
          </EditableField>
        </h1>
        <h2>
          <EditableField model="kola" item={bike} field="kratkypopis">
            {getBikeField(bike.data, 'kratkyPopis', "")}
          </EditableField>
        </h2>
        <div className="bike-example-blocker">
        <div ref={boxRef}>
             <h3 ref={textRef} dangerouslySetInnerHTML={{__html: ''}}></h3>
        </div>
        <EditableField model="kola" item={bike} field="obrazek" as="img" className="editry-fill-image">
          <img src={currentBikeImage || bike.data?.obrazek+"?format=webp" || testbike} alt={bike.data?.nazev || "Ridley bike"} />
        </EditableField>
        </div>

        <div className="bike-example-size">
          <h3>{getLocalizedText('bike.available_colors')}</h3>
          <div className="bike-example-size-color">
            {(bike.data?.barvy && Array.isArray(bike.data.barvy) && bike.data.barvy.length > 0) ? 
              bike.data.barvy.map((barva, index) => (
                <div 
                  key={index} 
                  className={index === selectedColorIndex ? "bike-example-size-color-active" : ""} 
                  onClick={() => handleColorChange(index)}
                >
                  <span style={{backgroundColor: barva.barva || "#000000"}} title={barva.jmenoBarvy || "Barva"} />
                </div>
              )) : (
                <>
                  <div className="bike-example-size-color-active"><span style={{backgroundColor: "#e61c1c"}}/></div>
                  <div><span style={{backgroundColor: "#1cd1e6"}} /></div>
                  <div><span style={{backgroundColor: "#1ce672"}} /></div>
                </>
              )
            }
          </div>

          <h3>{getLocalizedText('bike.available_sizes')}</h3>
          <div className="bike-example-size-size">
            {(dostupneVelikosti && Array.isArray(dostupneVelikosti) && dostupneVelikosti.length > 0) ? 
              dostupneVelikosti.map((velikost) => (
                <div 
                  key={velikost} 
                  className={size === velikost ? "bike-example-size-size-active" : ""}
                  onClick={() => setSize(velikost)}
                >
                  <span>{velikost}</span>
                </div>
              )) : (
                <>
                  <div className={size === "S" ? "bike-example-size-size-active" : ""} onClick={() => setSize("S")}><span>S</span></div>
                  <div className={size === "M" ? "bike-example-size-size-active" : ""} onClick={() => setSize("M")}><span>M</span></div>
                  <div className={size === "L" ? "bike-example-size-size-active" : ""} onClick={() => setSize("L")}><span>L</span></div>
                  <div className={size === "XL" ? "bike-example-size-size-active" : ""} onClick={() => setSize("XL")}><span>XL</span></div>
                </>
              )
            }
          </div>

          {/* Cena kola z bike.data.cena, dle země currency */}
          {bike.data?.cena && (
            <>
            <h3>{getLocalizedText('bike.price')}</h3>
            <div className="bike-price-value">
              <span className="price-amount">{getLocalizedText('bike.price-start')} {formatPrice(bike.data.cena)}</span>
              <ExchangeRateTooltip />
            </div>
            </>
          )}

          {kategorie.toUpperCase() === "GRAVEL" && (
          <>
            <h3>{getLocalizedText('general.pruvodce_text_small')}</h3>
            <NavLink to="/pruvodce/gravel"><button className="kolo-pruvodce-button"><span>{getLocalizedText('general.pruvodce_button_small')}</span></button></NavLink>
          </>
          )}

          {kategorie.toUpperCase() === "ROAD" && (
          <>
            <h3>{getLocalizedText('general.pruvodce_text_small')}</h3>
            <NavLink to="/pruvodce/road"><button className="kolo-pruvodce-button"><span>{getLocalizedText('general.pruvodce_button_small')}</span></button></NavLink>
          </>
          )}
        </div>

        <h1>{getLocalizedText('bike.about_product')}</h1>
        <p>
          <EditableField model="kola" item={bike} field="oproduktu">
            {getBikeField(bike.data, 'oProduktu', "Popis produktu není k dispozici")}
          </EditableField>
        </p>
      
        <div className="bike-example-gallery">
          {(galleryImages && Array.isArray(galleryImages) && galleryImages.length > 0) ? 
            galleryImages.map((image, index) => (
              <div key={index} onClick={() => openGallery(index)}>
                <DebugImage
                  src={image+"?format=webp" || testbike} 
                  alt={`Ridley bike gallery ${index + 1}`} 
                  style={{ cursor: 'pointer' }} 
                  onError={(e) => {
                    console.log('Image failed to load:', e.target.src);
                    console.log('Natural size:', e.target.naturalWidth, 'x', e.target.naturalHeight);
                    console.log('Browser:', navigator.userAgent);
                  }}
                  onLoad={(e) => console.log('Image loaded successfully:', e.target.src)}
                />
              </div>
            )) : (
              <div>
              </div>
            )
          }
        </div>

        {bike.data?.video && (
          <div className="bike-example-video">
            <ReactPlayer url={bike.data?.video} controls={true} />
          </div>
        )}

        {vlastnosti && bike.data?.vlastnosti && Array.isArray(bike.data.vlastnosti) && bike.data.vlastnosti.length > 0 && (
          <>
            <h1>{getLocalizedText('bike.features')}</h1>
            <div className="bike-vlastnosti">
              {bike.data.vlastnosti.map((vlastnost, index) => {
                const popis = vlastnost.popis || "Bez popisu";
                return (
                  <div key={index}>
                    <img
                      src={vlastnost.obrazek ? vlastnost.obrazek + "?format=webp" : (theme === "dark" ? telowhite : teloblack)}
                      alt={vlastnost.nazev || "Ridley vlastnosti kola"}
                    />
                    <div className="vlastnost-text">
                      <h3>{vlastnost.nazev || `Vlastnost ${index + 1}`}</h3>
                      {popis.length > 250 ? (
                        <>
                          <h4 className={vlastnostiExpanded === index ? "vlastnost-small vlastnosti-expanded" : "vlastnost-small vlastnosti-collapsed"}>{popis}</h4>
                          {vlastnostiExpanded === index ?
                            <button onClick={() => setVlastnostiExpanded(-1)}><span>{getLocalizedText('bike.close')}</span></button> :
                            <button onClick={() => setVlastnostiExpanded(index)}><span>{getLocalizedText('bike.get_more')}</span></button>
                          }
                        </>
                      ) : (
                        <h4>{popis}</h4>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

      <h1>
        {getLocalizedText('bike.specifications')}
        <EditableField model="kola" item={bike} field="specifikace" as="button" />
      </h1>
        <div className="bike-example-specifications">
          {(specifikaceList.nazevKategorie && Array.isArray(specifikaceList.nazevKategorie)) ? 
            specifikaceList.nazevKategorie.map((kategorie, kategIndex) => (
              <React.Fragment key={kategIndex}>
                <div 
                  className="category-header" 
                  onClick={() => toggleCategory(kategIndex)}
                  style={{ 
                    cursor: 'pointer', 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '10px 10px 10px 0',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ margin: 0, fontSize: '17px' }}>{kategorie.kategorie || `Kategorie ${kategIndex + 1}`}</h4>
                    <span style={{ 
                      fontSize: '15px', 
                      transform: openCategories[kategIndex] ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                      color: theme === "dark" ? '#4e4e4e' : '#333333',
                    }}>
                      ▼
                    </span>
                  </div>
  
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                    {kategorie.cena && (
                      <span style={{ 
                        fontSize: '15px', 
                        fontWeight: 'bold',
                        marginLeft: '15px',
                        color: '#000000',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        {formatPrice(kategorie.cena)}
                      </span>
                    )}
                  </div>
                </div>
                
                <div 
                  style={{ 
                    display: openCategories[kategIndex] === false ? 'none' : 'block',
                    transition: 'all 0.3s ease',
                    padding: '10px 0'
                  }}
                >
                  {(kategorie.specifikace && Array.isArray(kategorie.specifikace)) ? 
                    kategorie.specifikace.map((spec, specIndex) => (
                      <div 
                        key={specIndex}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '5px 0',
                          borderBottom: '1px dotted rgba(255, 255, 255, 0.1)'
                        }}
                      >
                        <h5 style={{ 
                          margin: 0, 
                          fontWeight: 'normal',
                          fontSize: '14px',
                          flex: 1
                        }}>
                          {spec.vlastniJmeno || translateSpecName(spec.jmenoSpecifikace) || `Specifikace ${specIndex + 1}`}
                        </h5>
                        <h6 style={{ 
                          margin: 0, 
                          fontWeight: 'bold',
                          fontSize: '14px',
                          textAlign: 'right',
                          color: theme === "dark" ? '#000000' : '#333333'
                        }}>
                          {spec.hodnotaSpecifikace || "N/A"}
                        </h6>
                      </div>
                    )) : (
                      <p>Žádné specifikace nejsou k dispozici</p>
                    )
                  }
                </div>
              </React.Fragment>
            )) : (
              <div className="empty-specifications">
                <p>Specifikace nejsou k dispozici</p>
              </div>
            )
          }
          <h3>{getLocalizedText('bike.spec_table_bottom_text')}</h3>
        </div>
        {/*<NavLink to={"https://www.ridley-bikes.com/en_CZ/configurator"}><button className="undspecbutton"><span className="konfigurator-topbar">Konfigurátor</span></button></NavLink>*/}

        {bike.data?.banner && (
          <NavLink to={"/konfigurator"}>
          <div className="config-banner">
            <img src="https://www.ridley-bikes.com/img/configurator-swirl.webp" alt="Configurator background"/>
            <h1>{getLocalizedText('bike.configure_custom')}</h1>
            <button><span>{getLocalizedText('configurator.configure')}</span></button>
          </div>
          </NavLink>
        )}

        {geometrieObrazek && (
        <>
          <h1>{getLocalizedText('bike.geometry')}</h1>
          <div className="bike-example-geometrie-box">
          <div className="bike-example-geometrie">
            <img className="bike-example-geometrie-image" src={geometrieObrazek+"?format=webp"} alt={getLocalizedText('bike.geometry')} />
          </div>
          </div>
          {geometriePdf && (<span className="download-pdf" onClick={() => {download()}}><FaRegFilePdf /> {getLocalizedText('bike.technical_info_download')}</span>)}
        </>
        )}

        {bike.data?.velikostniTabulka && (
          <button className="size-table-bike-button" onClick={() => {setTableModal({show: true, id: bike.data?.velikostniTabulka?.id})}}><label>{getLocalizedText('bike.size_table')}</label></button>
        )}

        <NavLink to="/prodejci">
        <div className="bike-example-store-banner">
            <div>
              <img src={banner} alt="Ridley bikes banner"/>
            </div>
            <span>{getLocalizedText('nav.dealers')}</span>
            <button><label  className="pointer">{getLocalizedText('general.show_button')}</label></button>
        </div>
        </NavLink>
      </div>
      </motion.div>
      {showGallery && (
        <div className="gallery-modal">
          <div className="gallery-modal-content">
            <button className="close-button" onClick={closeGallery}>
              <FaTimes />
            </button>
            
            <div className="gallery-image-container">
              <img 
                src={galleryImages[currentImageIndex]+"?format=webp"} 
                alt={`Ridley bike gallery ${currentImageIndex + 1}`} 
              />
            </div>
            
            <button className="nav-button prev" onClick={prevImage}>
              <FaArrowLeft />
            </button>
            
            <button className="nav-button next" onClick={nextImage}>
              <FaArrowRight />
            </button>
            
            <div className="gallery-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
